module.exports = __webpack_public_path__ + "img/quote-left.d8a8ecda.png";